import { Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import styled from "styled-components"

export const Wrapper = styled.div`
  align-items: center;
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  display: flex;
  gap: 16px;
  padding: 16px;
`

export const Avatar = styled.div`
  background: ${({ theme }: { theme: Theme }) => theme.palette.error.main};
  font-size: 15px;
  color: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  width: 40px;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  flex-shrink: 0;
  line-height: 1;
  user-select: none;
  border-radius: 50%;
  justify-content: center;
`

export const Content = styled.div`
  flex: 1 1 auto;
`

export const Title = styled(Typography.Paragraph)`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.15px;
  line-height: 1.43;
  margin: 0;
`

export const Subtitle = styled(Typography.Paragraph)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.main};
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.15px;
  line-height: 1.43;
  margin: 0;
`
